import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { adminLogin, formatApiError, getToken } from "../../lib/adminApi";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    // If already logged in, hop straight into dashboard
    if (getToken() && !submitting) {
        // Soft check — let user click again if token is invalid
    }

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await adminLogin(email.trim(), password);
            toast.success("Velkommen tilbage");
            navigate("/admin", { replace: true });
        } catch (err) {
            const msg = formatApiError(err);
            setError(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-900 px-6">
            <div className="absolute inset-0 bg-grid opacity-[0.07]" />
            <form
                onSubmit={submit}
                data-testid="admin-login-form"
                className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl p-8 border border-slate-200"
            >
                <div className="flex items-center gap-2 mb-1">
                    <span className="h-9 w-9 rounded-lg bg-gradient-to-br from-sky-500 to-sky-700 inline-flex items-center justify-center text-white">
                        <ShieldCheck className="h-4 w-4" />
                    </span>
                    <span className="font-display font-bold text-lg text-slate-900">Cleany Admin</span>
                </div>
                <p className="text-sm text-slate-500 mb-6">Log ind for at administrere waitlist og indlæg.</p>

                <label className="block text-xs font-semibold text-slate-700 mb-1.5">Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                    autoComplete="username"
                    data-testid="admin-login-email"
                    className="w-full h-11 px-3.5 rounded-lg border border-slate-300 focus:border-sky-500 focus:ring-2 focus:ring-sky-100 focus:outline-none text-sm"
                />

                <label className="block text-xs font-semibold text-slate-700 mt-4 mb-1.5">Adgangskode</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                    data-testid="admin-login-password"
                    className="w-full h-11 px-3.5 rounded-lg border border-slate-300 focus:border-sky-500 focus:ring-2 focus:ring-sky-100 focus:outline-none text-sm"
                />

                {error && (
                    <div className="mt-4 text-sm text-rose-700 bg-rose-50 border border-rose-100 rounded-lg px-3 py-2" data-testid="admin-login-error">
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={submitting}
                    data-testid="admin-login-submit"
                    className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-lg bg-slate-900 hover:bg-slate-800 disabled:opacity-60 text-white font-semibold h-11 transition-colors"
                >
                    {submitting && <Loader2 className="h-4 w-4 animate-spin" />}
                    Log ind
                </button>
            </form>
        </div>
    );
}
